import { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { cmsApi } from '@/lib/api';
import { toast } from 'sonner';
import { Loader2, Save } from 'lucide-react';

const AdminNewsletterPage = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [data, setData] = useState({
    title: '',
    subtitle: '',
    cta_label: '',
    helper_text: '',
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await cmsApi.getNewsletter();
        setData(res);
      } catch (error) {
        console.error('Failed to load newsletter content:', error);
        toast.error('B\u00fclten i\u00e7eri\u011fi y\u00fcklenemedi');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleChange = (field, value) => {
    setData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await cmsApi.updateNewsletter(data);
      toast.success('B\u00fclten sayfas\u0131 g\u00fcncellendi');
    } catch (error) {
      console.error('Failed to save newsletter content:', error);
      toast.error('B\u00fclten sayfas\u0131 kaydedilemedi');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center py-20">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-serif text-2xl font-bold text-foreground">B\u00fclten Sayfas\u0131</h1>
          <p className="text-sm text-muted-foreground">
            B\u00fclten sayfas\u0131n\u0131n ba\u015fl\u0131k, a\u00e7\u0131klama ve CTA metinlerini buradan y\u00f6net.
          </p>
        </div>
        <Button onClick={handleSave} disabled={saving} className="bg-primary text-primary-foreground hover:bg-primary/90">
          <Save className="h-4 w-4 mr-2" />
          {saving ? 'Kaydediliyor...' : 'Kaydet'}
        </Button>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Metinler</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4 max-w-2xl">
          <div className="space-y-2">
            <Label>Ba\u015fl\u0131k</Label>
            <Input
              value={data.title}
              onChange={(e) => handleChange('title', e.target.value)}
            />
          </div>
          <div className="space-y-2">
            <Label>A\u00e7\u0131klama</Label>
            <Textarea
              value={data.subtitle}
              onChange={(e) => handleChange('subtitle', e.target.value)}
              rows={3}
            />
          </div>
          <div className="space-y-2">
            <Label>CTA Metni</Label>
            <Input
              value={data.cta_label}
              onChange={(e) => handleChange('cta_label', e.target.value)}
            />
          </div>
          <div className="space-y-2">
            <Label>Yard\u0131mc\u0131 Metin</Label>
            <Input
              value={data.helper_text}
              onChange={(e) => handleChange('helper_text', e.target.value)}
            />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminNewsletterPage;
